import { render, staticRenderFns } from "./ChatTalkHeader.vue?vue&type=template&id=a3cef3e2&scoped=true&"
import script from "./ChatTalkHeader.vue?vue&type=script&lang=js&"
export * from "./ChatTalkHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cef3e2",
  null
  
)

export default component.exports